<template>
  <scoped v-if="value">
    <TextInput
      v-model:value="value.name"
      title="Name"
      :readOnly="readOnly"
    />
    <TextInput
      v-model:value="value.memorandum"
      title="Memorandum"
      multiline
      :readOnly="readOnly"
    />
  </scoped>
</template>

<script setup lang="ts">
  import TextInput from "@/components/inputs/text.vue"
  import {PropType} from "vue"
  import {Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<Supplier>
  })
</script>
